// Static copy and editorial choices for the logged-out homepage.
//
// Everything about a collection or a Pick (names, reward art, required titles,
// completion rules) is read live from the public API; this file only says
// which ones to feature first. A slug that is unpublished, inactive or whose
// reward window has ended is skipped, and the next published one fills in.
import darkKnightBronze from '../../../assets/coin_images/movies/dark_knight_coins/bronze.png';
import darkKnightSilver from '../../../assets/coin_images/movies/dark_knight_coins/silver.png';
import darkKnightGold from '../../../assets/coin_images/movies/dark_knight_coins/gold.png';
import darkKnightLegendary from '../../../assets/coin_images/movies/dark_knight_coins/legendary.png';

/** Collection whose reward coin is the hero centerpiece (The Black Pearl). */
export const HERO_COLLECTION_SLUG = 'seas-of-the-damned';

/** Collections shown in the "Earn coins" section, in order (hero collection excluded). */
export const FEATURED_COLLECTION_SLUGS = ['nolan-mastery', 'peele-horror', 'wick-suite', 'the-anime-starter-pack'];
export const FEATURED_COLLECTION_COUNT = 4;

/** Aluvo Picks shown in "Find your next watch", in order. */
export const FEATURED_PICK_SLUGS = ['survival-starter-pack', 'horror-starter-pack', 'avengers-doomsday-before-you-watch', 'anime-starter-pack'];
export const FEATURED_PICK_COUNT = 4;

/**
 * A member's published ranking to show on the homepage ("Our Top 20 TV Series
 * of All Time" by @thewatcher; the slug keeps the name it was created with).
 * REACT_APP_FEATURED_RANKING_SLUG overrides it. /share/rankings/:slug only
 * returns a ranking its owner published; once it is unpublished, deleted or
 * private the homepage falls back to EXAMPLE_RANKING_ITEMS.
 */
export const FEATURED_RANKING_SLUG = process.env.REACT_APP_FEATURED_RANKING_SLUG || 'our-top-10-tv-series-of-all-time-e5db89d';

/**
 * Titles for the example share image when no featured ranking is set. The
 * image comes from the same renderer the ranking editor uses for guests (ids
 * only: no title, no username).
 */
export const EXAMPLE_RANKING_ITEMS = [
    { kind: 'movie', tmdbId: 155 },    // The Dark Knight
    { kind: 'movie', tmdbId: 157336 }, // Interstellar
    { kind: 'movie', tmdbId: 680 },    // Pulp Fiction
    { kind: 'movie', tmdbId: 603 },    // The Matrix
    { kind: 'movie', tmdbId: 27205 },  // Inception
];

/** Coin tiers as enforced by the backend (utils/coinRarity.js, services/coinProgressionService.js). */
export const COIN_TIERS = [
    { key: 'bronze', label: 'Bronze', score: '5 of 8', detail: 'You passed. The title is verified.', image: darkKnightBronze },
    { key: 'silver', label: 'Silver', score: '6–7 of 8', detail: 'You know it well.', image: darkKnightSilver },
    { key: 'gold', label: 'Gold', score: '8 of 8', detail: 'A perfect score.', image: darkKnightGold },
    { key: 'legendary', label: 'Legendary', score: '8 of 8, twice', detail: 'Earn Gold, wait 24 hours, then score a perfect 8 again.', image: darkKnightLegendary },
];
